import { type CanvasElementOverrides } from '../canvas-element/canvas-element';
import { type CanvasElementProperties } from '../canvas-element/props';
import { type PropsSource, SourceType } from '../props-merger/props-source';
import { type RenderTarget } from '../renderer/render-target';

type GetRenderSourcesByTarget = (
  elementProps: CanvasElementProperties | undefined,
  elementOverrides: CanvasElementOverrides<object | undefined> | undefined,
  localStyleProps?: CanvasElementProperties,
  localStyleOverrides?: CanvasElementOverrides,
) => PropsSource[];

export const getRenderSourcesByTarget: Record<RenderTarget, GetRenderSourcesByTarget> = {
  desktop: (elementProps, _elementOverrides, localStyleProps) => [
    { value: localStyleProps, source: SourceType.LOCAL_STYLE },
    { value: elementProps, source: SourceType.ELEMENT_PROPS },
  ],
  tablet: (elementProps, elementOverrides, localStyleProps, localStyleOverrides) => [
    { value: localStyleProps, source: SourceType.LOCAL_STYLE },
    { value: elementProps, source: SourceType.ELEMENT_PROPS },
    { value: localStyleOverrides?.tablet?.props, source: SourceType.LOCAL_STYLE_TABLET },
    { value: elementOverrides?.tablet?.props, source: SourceType.ELEMENT_TABLET },
  ],
  mobile: (elementProps, elementOverrides, localStyleProps, localStyleOverrides) => [
    { value: localStyleProps, source: SourceType.LOCAL_STYLE },
    { value: elementProps, source: SourceType.ELEMENT_PROPS },
    { value: localStyleOverrides?.tablet?.props, source: SourceType.LOCAL_STYLE_TABLET },
    { value: elementOverrides?.tablet?.props, source: SourceType.ELEMENT_TABLET },
    { value: localStyleOverrides?.mobile?.props, source: SourceType.LOCAL_STYLE_MOBILE },
    { value: elementOverrides?.mobile?.props, source: SourceType.ELEMENT_MOBILE },
  ],
};
